import { useDispatch } from 'react-redux';

import { Button, ButtonVariants } from '@/components';
import { ListenRejectedReasons } from '@/constants';
import {
  selectActiveModalParams,
  selectIsB2CUser,
  selectUserCompliance,
  uiActions,
  useAppSelector,
  useFetchEpisodeQuery,
} from '@/store';

import {
  ListenRejectedModalComponent,
  ListenRejectedModalReason,
} from './ListenRejectedModal.component';

export const ListenRejectedModalContainer = () => {
  const dispatch = useDispatch();

  const compliance = useAppSelector(selectUserCompliance);
  const modalParams = useAppSelector(selectActiveModalParams);
  const isB2CUser = useAppSelector(selectIsB2CUser);

  const listenRejectedReason: ListenRejectedModalReason =
    modalParams?.listenRejectedReason || ListenRejectedReasons.UNKNOWN;
  const { episodeId } = modalParams || {};

  const { data: episode } = useFetchEpisodeQuery(
    { episodeId, compliance },
    { skip: !episodeId },
  );

  const close = () => dispatch(uiActions.closeActiveModal());

  const ContactButton = (
    <Button
      skinny={false}
      variant={ButtonVariants.PRIMARY}
      onClick={() => {
        window.Intercom?.('show');
        close();
      }}
      label="Contact Support"
    />
  );

  return (
    <ListenRejectedModalComponent
      fallbackButton={ContactButton}
      listenRejectedReason={listenRejectedReason}
      compliance={compliance}
      isB2CUser={isB2CUser}
      episodeName={episode?.name}
      episodeCover={episode?.cover}
      close={close}
    />
  );
};
